/* ============================================================
   AMVITAL Article JS — v3
   Desktop: TOC + Smooth Scroll + LiteYT
   Mobile:   No TOC, No Smooth Scroll, LiteYT deferred
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  var isDesktop = window.matchMedia("(min-width: 1024px)").matches;

  /* -------------------------------------------
     1. BUILD TABLE OF CONTENTS (H2 + H3 only)
        Desktop only (>=1024px)
  ------------------------------------------- */
  if (isDesktop) {
    (function buildTOC() {
      var tocWrapper = document.getElementById("amv-toc-wrapper");
      var toc = document.getElementById("amv-toc");
      if (!tocWrapper || !toc) return;

      var list = toc.querySelector("ol");
      if (!list) return;

      var intro = document.querySelector("article.intro");
      if (!intro) return;

      var headings = intro.querySelectorAll("h2, h3");
      if (!headings.length) return;

      var seen = {};

      function slugify(text) {
        var s = text
          .toLowerCase()
          .replace(/&/g, " and ")
          .replace(/[^a-z0-9\s-]/g, "")
          .trim()
          .replace(/\s+/g, "-")
          .replace(/-+/g, "-");

        if (seen[s]) {
          seen[s]++;
          s = s + "-" + seen[s];
        } else {
          seen[s] = 1;
        }
        return s;
      }

      headings.forEach(function (h) {
        var text = h.textContent.trim();
        if (!text) return;

        if (!h.id) h.id = slugify(text);

        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = "#" + h.id;
        a.textContent = text;
        li.appendChild(a);

        if (h.tagName === "H3") {
          li.style.marginLeft = "14px";
          li.style.fontSize = "0.92rem";
          li.style.opacity = "0.9";
        }

        list.appendChild(li);
      });

      toc.hidden = false;
    })();
  }

  /* -------------------------------------------
     2. SMOOTH SCROLL FOR TOC LINKS
        Desktop only — mobile left completely native
  ------------------------------------------- */
  if (isDesktop) {
    document.addEventListener("click", function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var targetID = link.getAttribute("href").slice(1);
      if (!targetID) return;

      var target = document.getElementById(targetID);
      if (!target) return;

      e.preventDefault();

      var y = target.getBoundingClientRect().top + window.pageYOffset - 10;
      window.scrollTo({ top: y, behavior: "smooth" });

      try {
        history.replaceState(null, "", "#" + targetID);
      } catch (err) {
        // ignore history errors
      }
    });
  }

  /* ============================================================
     3. LITE YOUTUBE EMBED
        Desktop → initialize immediately
        Mobile  → initialize ONLY on interaction
   ============================================================ */
  (function optimizedLiteYT() {
    var s = document.getElementById("amv-lite-yt");
    if (!s) return;

    var id = s.dataset.ytid;
    if (!id) return;

    function initLiteYT() {
      var play = s.querySelector(".amv-yt-play");
      var unmute = s.querySelector(".amv-yt-unmute");
      var thumb = s.querySelector(".amv-yt-thumb");

      var iframe = null;
      var ready = false;
      var queue = [];
      var startTs = null;
      var unmuted = false;

      function flush() {
        while (queue.length && ready && iframe && iframe.contentWindow) {
          var c = queue.shift();
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: c.func,
              args: c.args || []
            }),
            "*"
          );
        }
      }

      function buildIframe(opts) {
        opts = opts || {};
        var muted = opts.muted !== false;
        var start = opts.start || 0;

        var params = {
          autoplay: 1,
          playsinline: 1,
          enablejsapi: 1,
          modestbranding: 1,
          rel: 0,
          origin: location.origin
        };
        if (muted) params.mute = 1;
        if (start > 0) params.start = Math.floor(start);

        var iframeEl = document.createElement("iframe");
        iframeEl.src =
          "https://www.youtube.com/embed/" +
          id +
          "?" +
          new URLSearchParams(params).toString();
        iframeEl.allow = "autoplay; encrypted-media; picture-in-picture";
        iframeEl.setAttribute("allowfullscreen", "");
        iframeEl.style.cssText =
          "position:absolute;inset:0;width:100%;height:100%;border:0";
        return iframeEl;
      }

      function activateMuted() {
        if (iframe) return;

        iframe = buildIframe({ muted: true });
        s.appendChild(iframe);
        s.classList.add("iframe");

        if (thumb) thumb.style.display = "none";
        startTs = Date.now();

        setTimeout(flush, 500);
      }

      window.addEventListener("message", function (e) {
        try {
          var data = JSON.parse(e.data);
          if (data && data.event === "onReady") {
            ready = true;
            flush();
          }
        } catch (err) {
          // ignore non-JSON messages
        }
      });

      function queueCmd(func, args) {
        queue.push({ func: func, args: args });
        flush();
      }

      function start() {
        activateMuted();
        queueCmd("playVideo");
      }

      function getElapsed() {
        return startTs ? (Date.now() - startTs) / 1000 : 0;
      }

      function unmuteReplace() {
        if (unmuted) return;
        unmuted = true;

        var pos = getElapsed();
        var next = buildIframe({ muted: false, start: pos });

        if (iframe && iframe.parentNode) {
          iframe.parentNode.replaceChild(next, iframe);
        } else {
          s.appendChild(next);
        }

        iframe = next;
        ready = false;
        queue = [];

        setTimeout(function () {
          if (next.contentWindow) {
            next.contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "playVideo",
                args: []
              }),
              "*"
            );
          }
        }, 300);

        if (unmute) unmute.style.display = "none";
      }

      if (play) {
        play.addEventListener("click", start);
      }

      s.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          start();
        }
      });

      if (unmute) {
        unmute.addEventListener("click", unmuteReplace);
      }
    }

    /* ---- Desktop: initialize immediately (full experience) ---- */
    if (isDesktop) {
      initLiteYT();
      return;
    }

    /* ---- Mobile: initialize ONLY on first interaction ---- */
    var mobileInited = false;

    function initOnMobile() {
      if (mobileInited) return;
      mobileInited = true;
      initLiteYT();
      s.removeEventListener("click", initOnMobile);
      s.removeEventListener("keydown", keyInitHandler);
    }

    function keyInitHandler(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        initOnMobile();
      }
    }

    s.addEventListener("click", initOnMobile, { once: true });
    s.addEventListener("keydown", keyInitHandler);
  })();
});
